import Navbar from "../components/Navbar"
import Footer from "../components/Footer"

export default function HowItWorks(){

return(

<div className="app-shell">

<Navbar/>

<section className="page-section">
<div className="section-shell px-6">
<div className="content-card page-copy rounded-[2rem] p-8 md:p-12">

<div className="eyebrow">Process</div>

<h1 className="mb-8 mt-6 text-4xl font-bold text-stone-900 md:text-5xl">

How It Works

</h1>

<ul className="space-y-4 text-lg">

<li>Capture the gesture stream from the webcam.</li>

<li>MediaPipe identifies hand landmarks and key geometry.</li>

<li>Frames are prepared for the recognition model.</li>

<li>A CNN classifies the gesture into the predicted sign.</li>

<li>The prediction is converted into readable text output.</li>

<li>The system can be extended with speech output and richer feedback.</li>

</ul>

</div>
</div>
</section>

<Footer/>

</div>

)

}
